import cx from "classnames"
import * as React from "react"
import * as styles from "./styles.module.scss"
import ArticleTile from "../ArticleTile"

interface IProps {
  posts: Post[]
}

interface Post {
  node: {
    excerpt: string
    id: string
    frontmatter: {
      image: any
      tags: string[]
      title: string
    }
    fields: {
      slug: string
    }
  }
}

const ArticleList = ({ posts }: IProps) => {
  return (
    <ul className={styles.list}>
      {posts.map(({ node: post }) => {
        const { excerpt } = post
        const { slug } = post.fields
        const { image, title } = post.frontmatter
        const imageSrc = image?.childImageSharp?.fluid?.src
        return (
          <li className={styles.item} key={post.id}>
            <ArticleTile
              slug={`/content${slug}`}
              imageSrc={imageSrc}
              imageAlt={``}
              title={title}
              excerpt={excerpt}
            />
          </li>
        )
      })}
    </ul>
  )
}

export default ArticleList
